import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function ToitureFormBuilder() {
  const [fields, setFields] = useState([]);
  const [hasInput, setHasInput] = useState(false);
  const [order, setOrder] = useState(0);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setNewField({ ...newField, [name]: value });
//   };

const handleMoveField = (from, to) => {
  if (to < 0 || to >= fields.length) return; // éviter les débordements
  const newFields = moveItem(fields, from, to);
  setFields(newFields);
};

function moveItem(array, fromIndex, toIndex) {
  const updatedArray = [...array];
  const [movedItem] = updatedArray.splice(fromIndex, 1); // retire l'élément
  updatedArray.splice(toIndex, 0, movedItem); // insère à la nouvelle position
  return updatedArray;
}

  const notificationSave = () => {
      toast.success("Données enregistrées. Rechargez la page pour visualiser");
  }

  const notificationDelete = () => {
    toast.success("Données supprimées. Rechargez la page pour visualiser")
  }

  // 🔁 Charger depuis le localStorage au démarrage
  useEffect(() => {
    const saved = localStorage.getItem('toitureFormConfig');
    if (saved) {
      const parsed = JSON.parse(saved);
      setFields(parsed.fields || []);
    }
  }, []);

  const handleAddField = () => {
    setFields([...fields, { 
        title: '', 
        products: [],
        hasInput: hasInput,
        inputLabel: '',
        inputDescription: '',
        order: order,
        // inputType: '',
        // label: '', 
        type: 'text', 
        // options: [] 
    }]);
    setOrder( order + 1 );
    console.log('Order:', order)
  };

  const toggleInput = () => {
    setHasInput(!hasInput);
    console.log(hasInput);
  }

  const handleSave = () => {
    const toitureFormConfig = {
      title: 'Formulaire personnalisé',
      description: 'Créé depuis le backoffice',
      fields,
    };
    localStorage.setItem('toitureFormConfig', JSON.stringify(toitureFormConfig));
    // alert('Formulaire sauvegardé dans le localStorage.');
    console.log('Fields: ', fields)
    notificationSave();
  };

  const handleDelete = () => {
    localStorage.removeItem('toitureFormConfig');
    // setFields();
    notificationDelete();
  }

  const handleDeleteField = (indexToDelete) => {
    const updatedFields = [...fields];
    updatedFields.splice(indexToDelete, 1); // supprime le champ à l'index
    setFields(updatedFields);
    localStorage.setItem('toitureFormConfig', JSON.stringify({
        // title,
        // description,
        fields: updatedFields,
    }));
    };

  return (
    <div className=''>
      <ToastContainer position="top-right" autoClose={3000} />
      <h2>Créez Vos Sections</h2>
      {fields.map((field, index) => (
        <>
        <hr/>
          <div className="d-flex justify-content-between">
            <h3>Section</h3>
            <div className="">
              <button type='button' className='btn btn-primary' onClick={() => handleMoveField(index, index - 1)}>⬆️ Monter</button>
              <button type='button' className='btn btn-primary ms-3' onClick={() => handleMoveField(index, index + 1)}>⬇️ Descendre</button>
            </div>
          </div>
          
          <div key={index} className='row my-5'>
            <div className="col-md-3">
                <input
                    value={field.title}
                    onChange={(e) => {
                      const updatedFields = [...fields];
                      updatedFields[index].title = e.target.value;
                      setFields(updatedFields);
                    }}
                    placeholder="Titre du bloc"
                    className="form-control"
                />
            </div>
            <div className="col-md-3">
              <button
                type="button"
                className="btn btn-warning"
                onClick={() => {
                  const updatedFields = [...fields];
                  updatedFields[index].hasInput = !updatedFields[index].hasInput;
                  setFields(updatedFields);
                }}
              >
                {field.hasInput ? 'Supprimer le champ' : 'Ajouter un champ'}
              </button>
            </div>

            {field.hasInput && (
                <>
                    <div className="col-md-3">
                        <input
                            value={field.inputLabel}
                            onChange={(e) => {
                              const updatedFields = [...fields];
                              updatedFields[index].inputLabel = e.target.value;
                              setFields(updatedFields);
                            }}
                            placeholder="Titre du champ"
                            className="form-control"
                        />
                    </div>
                    <div className="col-md-3">
                        <input
                            value={field.inputDescription}
                            onChange={(e) => {
                              const updatedFields = [...fields];
                              updatedFields[index].inputDescription = e.target.value;
                              setFields(updatedFields);
                            }}
                            placeholder="Description du champ"
                            className="form-control"
                        />
                    </div>
                    <div className="col-md-3">
                      <select
                          value={field.type}
                          onChange={(e) => {
                            const updatedFields = [...fields];
                            updatedFields[index].type = e.target.value;
                            setFields(updatedFields);
                          }}
                          className="form-select"
                      >
                          <option value="text">Texte</option>
                          <option value="number">Nombre</option>
                          <option value="date">Date</option>
                          <option value="select">Liste déroulante</option>
                          <option value="file">Fichier</option>
                      </select>
                    </div>
                </>
            )   
            }
          
          {field.type === 'select' && (
            <div className="col-md-3">
                <input
                  type="text"
                  name="options"
                  value={field.options || ''}
                  onChange={(e) => {
                    const updatedFields = [...fields];
                    updatedFields[index].options = e.target.value.split(',').map(opt => opt.trim());
                    setFields(updatedFields);
                  }}
                  placeholder="Option 1, Option 2"
                  className="form-control"
                />
            </div>
          )}
          <div className="col-12 mt-3">
            <h5>Produits</h5>
            {field.products.map((prod, prodIndex) => (
              <div key={prodIndex} className="row mb-2">
                {/* <div className="col-md-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Image URL"
                    value={prod.imageUrl}
                    onChange={(e) => {
                      const updatedFields = [...fields];
                      updatedFields[index].products[prodIndex].imageUrl = e.target.value;
                      setFields(updatedFields);
                    }}
                  />
                </div> */}
                <div className="col-md-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Titre"
                    value={prod.title}
                    onChange={(e) => {
                      const updatedFields = [...fields];
                      updatedFields[index].products[prodIndex].title = e.target.value;
                      setFields(updatedFields);
                    }}
                  />
                </div>
                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Description"
                    value={prod.description}
                    onChange={(e) => {
                      const updatedFields = [...fields];
                      updatedFields[index].products[prodIndex].description = e.target.value;
                      setFields(updatedFields);
                    }}
                  />
                </div>
                <div className="col-md-2">
                  <button
                    className="btn btn-danger"
                    onClick={(e) => {
                      e.preventDefault();
                      const updatedFields = [...fields];
                      updatedFields[index].products.splice(prodIndex, 1);
                      setFields(updatedFields);
                    }}
                  >
                    Supprimer
                  </button>
                </div>
              </div>
            ))}

            <button
              className="btn btn-sm btn-secondary mt-2"
              onClick={(e) => {
                e.preventDefault();
                const updatedFields = [...fields];
                updatedFields[index].products.push({
                  // imageUrl: '',
                  title: '',
                  description: ''
                });
                setFields(updatedFields);
              }}
            >
              Ajouter un produit
            </button>
          </div>

          <div className="col-md-3">
            <button className='btn btn-danger mt-3' onClick={() => handleDeleteField(index)}>Supprimer la section</button>
          </div>
        </div>
        </>
      ))}
      <div className="mt-5">
        <button onClick={handleAddField} className="btn btn-primary me-4">Ajouter une section</button>
        <button onClick={handleSave} className="btn btn-success me-4">Sauvegarder</button>
        <button onClick={handleDelete} className="btn btn-danger">Réinitialiser</button>
      </div>
    </div>
  );
}

export default ToitureFormBuilder;